import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import { AdminAuthContext } from "../App";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setIsAdmin } = useContext(AdminAuthContext);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch("/backend/admin_auth.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include",
      });
      
      let data;
      try {
        data = await res.json();
      } catch {
        setError("Invalid server response");
        return;
      }
      
      if (res.status === 403) {
        // IP is blocked
        const remainingMinutes = data.remaining_minutes || 0;
        setError(`Access temporarily blocked due to multiple failed attempts. Please try again in ${remainingMinutes} minutes.`);
        return;
      }
      
      if (!res.ok) {
        setError(data.error || "Invalid username or password");
        return;
      }
      
      setIsAdmin(true); // Set admin state immediately
      navigate("/admin");
    } catch {
      setError("Login failed. Try again.");
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center">
        <form onSubmit={handleLogin} className="w-full max-w-sm p-8 bg-card rounded-lg shadow-lg border">
          <h2 className="text-2xl font-bold mb-6 text-foreground">Admin Login</h2>
          {error && <div className="mb-4 text-red-600 bg-red-50 dark:bg-red-900/20 p-3 rounded">{error}</div>}
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="mb-4"
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="mb-6"
            required
          />
          <Button type="submit" className="w-full">Login</Button>
        </form>
      </div>
      
      <Footer />
    </div>
  );
};

export default AdminLogin; 